import { BaseComponent2 } from '../../_common/client/base-component2';

export class OffersSellerComponent extends BaseComponent2 {
    public readonly rootSelector = '.js_of_offers-seller';

    public async onReloadComponentEvent(): Promise<unknown> {
        return Promise.resolve(undefined);
    }
}
